import React, {FC, useEffect, useMemo, useState} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import { useGetLMSModule } from "shared/hooks/api/useGetLMSModule";
import { API, Endpoints } from "@brg/api";
import { useLocation } from "react-router-dom";
import { parseUrlProjectId } from "shared/components/AudioPlayer/hooks/useTimecodesListener";

export const NotificationLMSComment: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;
    const location = useLocation()
    const urlProjectId = useMemo(() => parseUrlProjectId(location.pathname), [location.pathname])
    const lmsInfo = actions[0]?.lmsHomeWorkCommentInfo;
    const moduleProjectId = urlProjectId || lmsInfo?.moduleProjectId || "";
    
    const {LMSModuleInfo: lmsModuleInfo} = useGetLMSModule(moduleProjectId, false, false, false)
    const [targetTheme, setTargetTheme] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    
    useEffect(() => {
        if(lmsModuleInfo){
            setLoading(true)
           const findTheme = lmsModuleInfo?.themeInfos?.find(theme =>
            theme?.name?.some(n => n?.lang === 'ru' && n?.name === lmsInfo?.themeTitle)
        );
        if(!findTheme){
            setLoading(false)
            return;
        }
            
        API.request()
            .endpoint(Endpoints.longread)
            .url('api/post/GetMany')
            .addQuery('idUser', '2')
            .addQuery('idLongread', findTheme?.id ?? '')
            .get()
            .send()
            .then((r) => r.json())
            .then((r) =>{
                setTargetTheme(r)
                setLoading(false)
            })
            .catch(error => setLoading(false))
                }
    }, [lmsModuleInfo, lmsInfo])

    if (!lmsInfo) return null;

    if (lmsInfo?.isTeacher && !loading) return <SimpleTitle>
        {`Преподаватель `}
        <a href={window.location.origin + '/designer/' + lmsInfo?.initiator?.accountId}>
            {`${lmsInfo?.initiator?.name} ${lmsInfo?.initiator?.surName}`}
        </a>
        {` оставил комментарий к вашему заданию на тему `}
        <a href={window.location.origin + CreateLinkTo.project(lmsInfo?.moduleProjectId) + `#${targetTheme?.[0]?.postId}`}>
            "{lmsInfo?.themeTitle}"
        </a>
    </SimpleTitle>

    // студент лмс отправил коммент
    return <SimpleTitle>
        <a href={window.location.origin + '/designer/' + lmsInfo?.initiator?.accountId}>
            {`${lmsInfo?.initiator?.name} ${lmsInfo?.initiator?.surName}`}
        </a>
        {` оставил комментарий к теме `}
        <a href={process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.checkHomework(lmsInfo?.initiatorId, lmsInfo?.moduleProjectId, lmsInfo?.themeLongreadId)}>
            "{lmsInfo?.themeTitle}"
        </a>
    </SimpleTitle>
}import React, {FC, useEffect, useMemo, useState} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";
import { useGetLMSModule } from "shared/hooks/api/useGetLMSModule";
import { API, Endpoints } from "@brg/api";
import { useLocation } from "react-router-dom";
import { parseUrlProjectId } from "shared/components/AudioPlayer/hooks/useTimecodesListener";

export const NotificationLMSComment: FC<{item: any}> = ({item}) => {
    const {
        actions,
    } = item;
    const location = useLocation()
    const urlProjectId = useMemo(() => parseUrlProjectId(location.pathname), [location.pathname])
    const lmsInfo = actions[0]?.lmsHomeWorkCommentInfo;
    const moduleProjectId = urlProjectId || lmsInfo?.moduleProjectId || "";
    
    const {LMSModuleInfo: lmsModuleInfo} = useGetLMSModule(moduleProjectId, false, false, false)
    const [targetTheme, setTargetTheme] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    
    useEffect(() => {
        if(lmsModuleInfo){
            setLoading(true)
           const findTheme = lmsModuleInfo?.themeInfos?.find(theme =>
            theme?.name?.some(n => n?.lang === 'ru' && n?.name === lmsInfo?.themeTitle)
        );
        if(!findTheme){
            setLoading(false)
            return;
        }
            
        API.request()
            .endpoint(Endpoints.longread)
            .url('api/post/GetMany')
            .addQuery('idUser', '2')
            .addQuery('idLongread', findTheme?.id ?? '')
            .get()
            .send()
            .then((r) => r.json())
            .then((r) =>{
                setTargetTheme(r)
                setLoading(false)
            })
            .catch(error => setLoading(false))
                }
    }, [lmsModuleInfo, lmsInfo])

    if (!lmsInfo) return null;

    if (lmsInfo?.isTeacher && !loading) return <SimpleTitle>
        {`Преподаватель `}
        <a href={window.location.origin + '/designer/' + lmsInfo?.initiator?.accountId}>
            {`${lmsInfo?.initiator?.name} ${lmsInfo?.initiator?.surName}`}
        </a>
        {` оставил комментарий к вашему заданию на тему `}
        <a href={window.location.origin + CreateLinkTo.project(lmsInfo?.moduleProjectId) + `#${targetTheme?.[0]?.postId}`}>
            "{lmsInfo?.themeTitle}"
        </a>
    </SimpleTitle>

    // студент лмс отправил коммент
    return <SimpleTitle>
        <a href={window.location.origin + '/designer/' + lmsInfo?.initiator?.accountId}>
            {`${lmsInfo?.initiator?.name} ${lmsInfo?.initiator?.surName}`}
        </a>
        {` оставил комментарий к теме `}
        <a href={process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.checkHomework(lmsInfo?.initiatorId, lmsInfo?.moduleProjectId, lmsInfo?.themeLongreadId)}>
            "{lmsInfo?.themeTitle}"
        </a>
    </SimpleTitle>
}